import { gql } from "@apollo/client";

const searchSkillsQuery = gql`
  query searchSkills($organizationId: Int) {
    searchSkills(organizationId: $organizationId) {
      __typename
      ... on SkillNode {
        name
        slug
        description
        visibility
      }
      ... on PlatformSkillType {
        name
        slug
        description
        visibility
      }
    }
  }
`;

export default searchSkillsQuery;
